import { render, staticRenderFns } from "./rank_list.vue?vue&type=template&id=5aa911a7&scoped=true"
import script from "./rank_list.vue?vue&type=script&lang=js"
export * from "./rank_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa911a7",
  null
  
)

export default component.exports